import { useMutation, useQueryClient } from 'react-query'

import { v1UserQueries } from '@webapp/platform/iam/query-configs/v1UserQueries'
import { type SlackIntegrationError } from '@webapp/platform/integrations/business-logic/errors/SlackIntegrationError'
import { slackIntegrationRepository } from '@webapp/platform/integrations/data-access/repositories/SlackIntegrationRepository'

export const useSyncUnlinkedSlackUsersModel = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<void, SlackIntegrationError, void>({
    mutationFn: () => {
      return slackIntegrationRepository.syncUnlinkedUsers()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: v1UserQueries.activeUsers().queryKey,
      })
    },
  })

  return {
    syncUnlinkedUsers: mutation.mutateAsync,
    isSyncing: mutation.isLoading,
  }
}
